import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { IPagination } from '@models/pagination';
import { config } from '@services/config';

export interface IProductLabel {
  id: string;
  createdAt: string;
  updatedAt: string;
  insuranceProductId: string;
  name: string;
  productCodeOverride?: string | null;
  description?: string | null;
}

export const useProductLabels = (insuranceProductId?: string) => {
  const client = useClient();
  const queryParams = new URLSearchParams();
  queryParams.append('pageLimit', '50');
  queryParams.append('sort', '+name');
  const result = useQuery<IProductLabel[], Error>({
    queryKey: ['productLabel', { insuranceProductId }],
    queryFn: async () => {
      const response = await client
        .get(`insurance-product/${insuranceProductId}/product-label?${queryParams}`)
        .json<IPagination<IProductLabel>>();
      return response.items;
    },
    enabled: !!insuranceProductId,
    ...config,
  });
  return { ...result, productLabels: result.data || [] };
};
